// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"23b40278","198":"893231c9","430":"252d7a7d","460":"9469bd18","488":"0491610c"}[chunkId] + ".chunk.js";
};